import {Component, OnInit} from '@angular/core';
import {ContractObjectBaseComponent} from "../contract-object-base.component";


@Component({
    selector: 'cm-contract-object-mini-side-component',
    templateUrl: 'contract-object-mini-side.component.html',
    standalone: false
})
export class ContractObjectMiniSideComponent extends ContractObjectBaseComponent implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }


}
